<div class="detail-card-container">
  <mat-toolbar class="sub-budget-toolbar">
    <div class="sub-budget-toolbar__left">
      <div class="sub-budget-title-container">
        @if (isEditingName) {
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Sub-Budget Name</mat-label>
            <input #nameInput cdkFocusInitial (blur)="updateName(nameInput.value); isEditingName = false"
                   (keyup.enter)="updateName(nameInput.value); isEditingName = false"
                   [value]="subBudgetName"
                   matInput minlength="3" required>
          </mat-form-field>
        } @else {
          <h2 class="sub-budget-title">{{ subBudgetName }}</h2>
          @if (canEdit || subBudgetName?.includes('MERGE_')) {
            <button (click)="isEditingName = true" mat-icon-button matTooltip="Rename Sub-Budget">
              <mat-icon>edit</mat-icon>
            </button>
          }
        }
      </div>
      <div class="toolbar-form-row">
        <mat-form-field class="sub-budget-tag-list" subscriptSizing="dynamic">
          <mat-label>Tags</mat-label>
          <mat-chip-grid #chipGrid aria-label="Fruit selection">
            @for (tag of subBudgetTags; track tag) {
              <mat-chip-row (removed)="removeTag(tag)">
                {{ tag }}
                <button matChipRemove [attr.aria-label]="'remove'">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            }
            <input
              name="subBudgetTags"
              placeholder="Tags..."
              [matChipInputFor]="chipGrid"
              [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
              (matChipInputTokenEnd)="addTag($event)"
            />
          </mat-chip-grid>
        </mat-form-field>
      </div>
    </div>

        <div class="sub-budget-toolbar__right">

          @if (subBudgetTotals) {
            <div>
              <span i18n>Total</span>:&nbsp;
              <span>{{ subBudgetTotals.total | currency:budget && budget.export ? 'USD' : 'EUR' }}</span>&nbsp;|&nbsp;
              <span>{{ (calculate ? subBudgetTotals.total / budgetTotal * 100 : 0)| number:'1.0-2' }} %</span>
            </div>
          }
          <!-- Toggle button to disable budget -->
          @if (calculateToggleEnabled && canEdit) {
            <mat-slide-toggle style="padding-left: 5px;" (change)="toggleCalculate($event)"
              [checked]="!calculate">Disable
            </mat-slide-toggle>
          }
          @if (vacancyBtn || canEdit) {
            <button [matMenuTriggerFor]="menu" mat-icon-button>
              <mat-icon>more_vert</mat-icon>
            </button>
          }
          <mat-menu #menu="matMenu">
            @if (vacancyBtn) {
              <button (click)="generateVacancyActivity()" mat-menu-item>
                <mat-icon>directions_walk</mat-icon>
                <span i18n>Generate Vacancy Activity</span>
              </button>
            }
            @if (canEdit) {
              <button (click)="deleteSubBudget()" [disabled]="canNotDelete" mat-menu-item>
                <mat-icon>delete</mat-icon>
                <span i18n>Delete Sub Budget</span>
              </button>
            }
            @if (canEdit) {
              <button (click)="copySubBudget()" mat-menu-item>
                <mat-icon>file_copy</mat-icon>
                <span i18n>Duplicate Sub Budget</span>
              </button>
            }
          </mat-menu>
        </div>
      </mat-toolbar>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title i18n>Activities</mat-panel-title>
          <mat-panel-description>
            <span>Total</span>:&nbsp;
            <span>{{ subBudgetTotals?.activities | currency:budget && budget.export ? 'USD' : 'EUR' }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <form #f="ngForm" (ngSubmit)="commitActivities(f)" novalidate>
          <mat-table #table [dataSource]="activitiesDataSource">
            <!-- Nome Column -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef i18n>Activity</mat-header-cell>
              <mat-cell *matCellDef="let row"> {{ row.activity }}</mat-cell>
            </ng-container>

            <!-- Category Column -->
            <ng-container matColumnDef="category">
              <mat-header-cell *matHeaderCellDef i18n>Category</mat-header-cell>
              <mat-cell *matCellDef="let row"> {{ categoryMap.get(row.category) }}</mat-cell>
            </ng-container>

            <!-- Costo Column -->
            <ng-container matColumnDef="cost">
              <mat-header-cell *matHeaderCellDef i18n>Cost</mat-header-cell>
              <mat-cell *matCellDef="let row"> {{ row.cost | currency:budget && budget.export ? 'USD' : 'EUR' }}
              </mat-cell>
            </ng-container>

            <!-- Ore Column -->
            <ng-container matColumnDef="hours">
              <mat-header-cell *matHeaderCellDef i18n>Hours</mat-header-cell>
              <mat-cell *matCellDef="let row"> {{ row.hours }}</mat-cell>
            </ng-container>

            <!-- Ore Column -->
            <ng-container matColumnDef="hoursNew">
              <mat-header-cell *matHeaderCellDef i18n>Hours</mat-header-cell>
              <mat-cell *matCellDef="let row">
                <mat-form-field class="hours-input-field">
                  <input #hours [(ngModel)]="avm[row.id]" [name]="row.id" matInput min="0" type="number">
                </mat-form-field>
              </mat-cell>
            </ng-container>

            <!-- Importo Column -->
            <ng-container matColumnDef="importoCalc">
              <mat-header-cell *matHeaderCellDef i18n>Amount</mat-header-cell>
              <mat-cell *matCellDef="let row"> {{ row.cost * avm[row.id] | number:'1.0-2' }}</mat-cell>
            </ng-container>

            <!-- Importo Column -->
            <ng-container matColumnDef="amount">
              <mat-header-cell *matHeaderCellDef i18n>Amount</mat-header-cell>
              <mat-cell *matCellDef="let row"> {{ row.amount | number:'1.0-2' }}</mat-cell>
            </ng-container>

            <!-- Color Column -->
            <ng-container matColumnDef="weight">
              <mat-header-cell *matHeaderCellDef i18n>Weight</mat-header-cell>
              <mat-cell *matCellDef="let row" [style.color]="row.color">
                {{ 100 * row.cost * avm[row.id] / budgetTotal | number:'1.0-2' }} %
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="activitiesColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: activitiesColumns;"></mat-row>
          </mat-table>
          @if (canEdit) {
            <mat-action-row>
              <button [disabled]="f.invalid" mat-button type="submit">Save</button>
            </mat-action-row>
          }
        </form>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title i18n="Title of the list of external goods to be purchased">
                Materials
            </mat-panel-title>
          <mat-panel-description>
            <span i18n>Total</span>:&nbsp;
            <span>{{ subBudgetTotals?.materials | currency:budget && budget.export ? 'USD' : 'EUR' }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-table #table [dataSource]="materialDataSource">

          <!-- Nome Column -->
          <ng-container matColumnDef="description">
            <mat-header-cell *matHeaderCellDef i18n>Material</mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ row.description }}
              @if (row.manualSpecified && row.description.includes('Commissions')) {
                <mat-icon color="accent" class="ml-1" matTooltip="amount manually specified"
                  >
                  edit_note
                </mat-icon>
              }
            </mat-cell>
          </ng-container>

          <!-- Costo Column -->
          <ng-container matColumnDef="costEach">
            <mat-header-cell *matHeaderCellDef i18n>Cost Each</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.costEach | number:'1.0-2' }}</mat-cell>
          </ng-container>

          <!-- Category Column -->
          <ng-container matColumnDef="category">
            <mat-header-cell *matHeaderCellDef i18n>Category</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ categoryMap.get(row.category) }}</mat-cell>
          </ng-container>

          <!-- Costo Column -->
          <ng-container matColumnDef="unit">
            <mat-header-cell *matHeaderCellDef i18n>Unit</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.unit }}</mat-cell>
          </ng-container>

          <!-- Ore Column -->
          <ng-container matColumnDef="quantity">
            <mat-header-cell *matHeaderCellDef i18n>Quantity</mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ row.quantity }}
            </mat-cell>
          </ng-container>

          <!-- Importo Column -->
          <ng-container matColumnDef="amount">
            <mat-header-cell *matHeaderCellDef i18n>Amount</mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ row.quantity * row.costEach | number:'1.0-2' }}
            </mat-cell>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="weight">
            <mat-header-cell *matHeaderCellDef i18n>Weight</mat-header-cell>
            <mat-cell *matCellDef="let row" [style.color]="row.color">
              {{ 100 * row.quantity * row.costEach / budgetTotal | number:'1.0-2' }} %
            </mat-cell>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef i18n>Actions</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <button mat-icon-button title="Edit Material Entry">
                <mat-icon (click)="openMaterialDialog('edit', row)">edit</mat-icon>
              </button>
              <button mat-icon-button title="Copy Material Entry">
                <mat-icon (click)="openMaterialDialog('copy', row)">file_copy</mat-icon>
              </button>
              <button [disabled]="row.hasOrders" (click)="deleteMaterial(row)" mat-icon-button
                title="Delete Material Entry">
                <mat-icon>delete</mat-icon>
              </button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="materialsColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: materialsColumns;"></mat-row>
        </mat-table>
        <mat-action-row align="end">
          @if (canEdit) {
            <button (click)="openMaterialDialog('add')" color="accent" mat-fab>
              <mat-icon>add</mat-icon>
            </button>
          }
        </mat-action-row>
      </mat-expansion-panel>
    </div>
